import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  title?: string;
  message?: string;
  showRetry?: boolean;
  onRetry?: () => void;
  className?: string;
}

export function ErrorDisplay({ 
  title = "Something went wrong",
  message = "An error occurred while loading the data. Please try again.",
  showRetry = true,
  onRetry,
  className = ""
}: ErrorDisplayProps) {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className={`text-center ${className}`}>
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md mx-auto">
        <div className="flex justify-center mb-4">
          <AlertCircle className="w-8 h-8 text-red-600" />
        </div>
        <h2 className="text-xl font-semibold text-red-900 mb-2">{title}</h2>
        <p className="text-red-700 mb-4">{message}</p>
        {showRetry && (
          <button 
            onClick={handleRetry}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
} 